namespace SP {
    export interface ShippingMethodParcelType {
        code: string;
        name: string;
        enabled: boolean;
    }
}